// extracted by mini-css-extract-plugin
module.exports = {"create":"create_create__2Xfby","container":"create_container__1mfue","header":"create_header__39D6w","inputField":"create_inputField__3PFUA","submit":"create_submit__1ze79"};